/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    /*
    MoyaComponents.register('ext.accordion', [
        '/static/local/accordion/js/accordion.js',
    ], (el) => {
        Accordion.init();
    })
     */
    var moyaToggle = MoyaContainer.get('core.toggle');
    var sections = document.querySelectorAll('section.accordion');
    var accordionCounter = 0;
    Array.prototype.forEach.call(sections, function (el) {
        //el.dataset.moyaComponent = 'ext.accordion';
        var wrapElements = function (elements, wrapper) {
            if (elements && elements.length) {
                elements[0].parentNode.insertBefore(wrapper, elements[0]);
                elements.forEach(function (child) { return wrapper.appendChild(child); });
            }
        };
        //Wrap title in button
        var title = el.querySelector('*:first-child');
        var button = document.createElement('button');
        button.innerHTML = title.innerHTML;
        title.innerHTML = '';
        title.parentNode.insertBefore(button, title);
        title.remove();
        //Wrap content
        var wrapper = document.createElement('div');
        wrapper.classList.add('wrap');
        wrapper.id = 'accordion-' + ++accordionCounter;
        wrapper.dataset.moyaComponent = "core.max-height";
        wrapElements(el.querySelectorAll(':scope >*:not(:first-child)'), wrapper);
        moyaToggle.create(button, wrapper, 'accordion' + accordionCounter, {
            'onOpen': function (toggle) {
                toggle.getOpenElement().parentElement.classList.add('open');
            },
            'onClose': function (toggle) {
                toggle.getOpenElement().parentElement.classList.remove('open');
            },
            'closeOnBodyClick': false,
        });
        el.classList.add('ready');
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
